import React from 'react';

const TextInputField = ({
  label,
  value,
  onChange,
  type = 'text'
}) => (
  <label className="block">
    <span className="block text-sm text-gray-300 mb-1">{label}</span>
    <input
      type={type}
      value={value || ''}
      onChange={(event) => onChange(event.target.value)}
      className="w-full bg-gray-800/50 backdrop-blur text-white placeholder-gray-500 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-violet-500 border border-gray-700"
    />
  </label>
);

const TextAreaField = ({ label, value, onChange }) => (
  <label className="block">
    <span className="block text-sm text-gray-300 mb-1">{label}</span>
    <textarea
      value={value || ''}
      onChange={(event) => onChange(event.target.value)}
      rows={2}
      className="w-full bg-gray-800/50 backdrop-blur text-white placeholder-gray-500 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-violet-500 border border-gray-700 resize-y"
    />
  </label>
);

const formatLabel = (label, key) => {
  if (key === 'title') {
    return `${label} (Mr / Mrs / Miss / ...)`;
  }
  if (key === 'position') {
    return `${label} (CEO / Engineer / Sales / ...)`;
  }
  return label;
};

const PrimaryFieldInputs = ({ fields, values, onFieldChange }) => (
  <>
    {Array.isArray(fields) && fields.map((field) => {
      const baseLabel = field.label || field.attribute;
      const label = formatLabel(baseLabel, field.key);
      const value = values[field.key];
      const handleChange = (nextValue) => onFieldChange(field.key, nextValue);

      if (field.key === 'address') {
        return (
          <TextAreaField
            key={field.key}
            label={label}
            value={value}
            onChange={handleChange}
          />
        );
      }

      const isEmail = field.key === 'email';

      return (
        <TextInputField
          key={field.key}
          label={label}
          value={value}
          onChange={handleChange}
          type={isEmail ? 'email' : 'text'}
        />
      );
    })}
  </>
);

export { PrimaryFieldInputs };

